import { render, staticRenderFns } from "./modalVisualizar.vue?vue&type=template&id=c2c07f74&scoped=true&"
import script from "./modalVisualizar.vue?vue&type=script&lang=js&"
export * from "./modalVisualizar.vue?vue&type=script&lang=js&"
import style0 from "./modalVisualizar.vue?vue&type=style&index=0&id=c2c07f74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c07f74",
  null
  
)

export default component.exports